import { OutputTechnology } from '@enmon/commons/lib/tools';
import { Space, Tooltip } from 'antd';
import { Tag } from 'components';
import type { FC } from 'react';
import { outputTechnologyTranslated } from 'routes/portfolio/locations/const';

interface InbuiltOutputsProps {
  outputs: OutputTechnology[];
}

/** The model's inbuilt outputs as page-header tags (like the meter header's tags), in the enum's order. */
export const InbuiltOutputs: FC<InbuiltOutputsProps> = ({ outputs }) => {
  const present = Object.values(OutputTechnology).filter(output => outputs.includes(output));

  if (present.length === 0) {
    return (
      <Tooltip title="The model has no output readable without buying a module">
        <Tag>No inbuilt outputs</Tag>
      </Tooltip>
    );
  }

  return (
    <Space wrap size={[8, 0]}>
      {present.map(output => (
        <Tooltip key={output} title="Inbuilt output">
          <Tag color="cyan">{outputTechnologyTranslated[output]}</Tag>
        </Tooltip>
      ))}
    </Space>
  );
};
